
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";
import {
  Manager,
  Source,
  Tag,
  User,
} from "@/generated/graphql";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import ContractorResourceNotesModal from "@/components/common/ContractorResourceNotesModal.vue";
import EditResourceInformationModal from "@/components/common/EditResourceInformationModal.vue";
import AddResourceInformationModal from "@/components/common/AddResourceInformationModal.vue";
import RouteNames from "@/entities/RouteNames";
import DELETE_MANAGER from "@/apollo/managers/DeleteManagersProfile.gql";
import UIButton from "@/components/button/ui-button.vue";
import ResourceCardPagination from "@/components/card/ResourceCardPagination.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import moment from "moment";
import S3Image from "@/components/common/s3-image.vue";
// import { hslColorFromName } from "@/utils/hslColorFromName";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
// import ManagerStatus from "@/entities/manager/ManagerStatus";
import getAuthData from "@/utils/getAuthData";
import UPDATE_STATUS_CHANGE from '@/apollo/managers/UpdateStatusChange.gql'

@Component({
  components: {
    UiButton,
    ContractorResourceNotesModal,
    EditResourceInformationModal,
    AddResourceInformationModal,
    UIButton,
    ResourceCardPagination,
    CircleWithInitials,
    S3Image,
  },
})
export default class ManagersTable extends Vue {
  @Prop({ type: String, required: false }) readonly contractorId!: string;
  @Prop({ type: String, required: false }) readonly currentUserId!: string;
  @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
  @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;
  @Prop({ type: String, default: undefined }) readonly image?: string;
  @Prop({ type: Boolean, default: false }) readonly primary!: boolean;
  @Prop({ type: String, default: undefined }) readonly initial?: string;
  @Prop({ type: Array, default: () => [] }) readonly managersTable!: Manager[];
  @Prop({ type: [String, Object], default: undefined }) readonly itemLink?:
    | string
    | object;
  @Prop({ type: Boolean, default: false }) readonly isManager!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;
  // @Prop({type: String, default: undefined}) readonly initial?: string;

  managerDeletionProcessing = false;

  created() {
    this.managers();
  }
  _id: string = "";
  _usrId: string = "";
  get avatarStyleClasses(): Record<string, boolean> {
    return {
      [this.avatarClasses]: Boolean(this.avatarClasses),
      ["border border-primary"]: this.highlightAvatar,
    };
  }
  paginationConfig: PaginationConfig = { ...paginationConfig };

  tag: Tag[] = [];
  source: Source[] = [];
  user: User[] = [];
  manager!: any[];
  selectedId: string = "";
  modalDisplay: boolean = false;
  //@ts-ignore
  getFormattedDate(date): string {
    return moment(date).format("DD/MM/YY");
  }

  managers(): Manager[] {
    //@ts-ignore
    this.manager = this.managersTable; //@ts-ignore
    return this.manager;
  }
  get tagName(): Tag {
    //@ts-ignore
    return this.resourceCard!.tag?.name;
  }
  checkVal(): void {}
  get getTagName(): Tag {
    //@ts-ignore
    // console
    return this.resourceCard[0].tag?.name;
  }
  get bgStyle(): object {
    return {
      background: "#1A7BEE",
    };
  }
  get contractorId_(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      offset: nextOffset,
      contractor_id: this.contractorId,
    };
  }
  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center mt-2 justify-center";
  }
  get defaultImageClasses(): string {
    return "inline-block rounded-full object-cover object-center";
  }

  //@ts-ignore
  toggleShow(val): void {
    this.selectedId = val.user.id;
    this.modalDisplay = !this.modalDisplay;
    // if(this.modalDisplay === true) {
    //   this.selectedManager = val.id;
    // } else {
    //   this.selectedManager = null;
    // }
  }

  //@ts-ignore
  removeNote(data): void {
    this._id = data.id;
    this._usrId = data.user.id;
    this.$confirm({
      title: `Delete Manager`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
          try {
            this.managerDeletionProcessing = true;
            await this._deleteManager(data);
            await this._deleteCognitoUserPool();
            this.$eventBus.emit(
              NOTIFICATION,
              Message.successMessage("Manager Deleted")
            );
          } catch (e) {
            this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
          } finally {
            this.managerDeletionProcessing = false;
          }
        }
      },
    });
  }
  message(item: Manager): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: item.user.id,
      },
    });
  }

  viewProfile(item: Manager): void {
    this.$router.push({
      name: RouteNames.MANAGER_ABOUT,
      params: {
        id: item.id,
      },
    });
  }
  //@ts-ignore
  _deleteManager(data) {
    this._id = data.id;
    this._usrId = data.user.id;
    this.$eventBus.emit(
      NOTIFICATION,
      Message.successMessage("Manager deleted successfully")
    );
    this.refreshPage();
    //   this.currentUserId = await auth.getSession
    return this.$apollo.mutate({
      mutation: DELETE_MANAGER,
      variables: {
        id: this._usrId,
        managerId: this._id,
        currentUserId: this.currentUserId,
      },
    });
  }

  async _deleteCognitoUserPool() {
    try {
      const uri = `${process.env.VUE_APP_LAMBDA}/delete-cognito-user`;
      const { headers } = await getAuthData();
      const { data }: any = await this.axios.post(
        uri,
        {
          data: {
            username: this._usrId,
          },
        },
        { headers }
      );
      return data.valid;
    } catch (error) {
      return false;
    } finally {
    }
  }
  //  isManagerSuspended(data): boolean {
  //   return this.manager.status === ManagerStatus.SUSPENDED;
  // }

  disablee(data: Manager): void {
    // data.status = 'SUSPENDED'
    this.$confirm({
      title: `Suspend Manager`,
      message: `Are you sure?`,
      button: {
        no: "No",
        yes: "Yes",
      },
      callback: async (confirm: any) => {
        if (confirm) {
        this.$apollo.mutate({
        mutation: UPDATE_STATUS_CHANGE,
        variables: {
            id: data.id
        }
           
      },
      
    )}
    this.refreshPage()
   
        }
    })
 

  }

  refreshPage(): void {
    window.location.reload();
    this.$emit("refresh");
  }
}
